/**
 * Ponowny klik pozycji menu z przypisanym widokiem (`?mi=`) — sygnał dla tabel listy.
 *
 * Gdy karta kartoteki jest już otwarta, klik tej samej pozycji w pasku nie zmienia adresu (ani
 * wskazanego układu), więc tabela nie wie, że ma wrócić do układu STARTOWEGO pozycji. Pasek
 * ogłasza klik zdarzeniem okna; `useTableLayout` kasuje wtedy ręczny wybór widoku
 * (decyzja 2026-10-05: przypięty układ jest startowy dla pozycji, użytkownik może przełączyć).
 */

export const MENU_ITEM_ACTIVATED_EVENT = 'saas:menu-item-activated';

export interface MenuItemActivatedDetail {
  /** Id klikniętej pozycji (to samo, co idzie w `?mi=`) — tabela resetuje się tylko w karcie tej pozycji. */
  menuItemId: string;
}

/** Klik bez modyfikatorów lewym przyciskiem — otwarcie w nowej karcie przeglądarki nie resetuje bieżącej. */
function isPlainLeftClick(e: {
  button: number;
  metaKey: boolean;
  ctrlKey: boolean;
  shiftKey: boolean;
  altKey: boolean;
}): boolean {
  return e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey;
}

export function announceMenuItemActivated(
  menuItemId: string,
  event?: {
    button: number;
    metaKey: boolean;
    ctrlKey: boolean;
    shiftKey: boolean;
    altKey: boolean;
  },
): void {
  if (event && !isPlainLeftClick(event)) return;
  window.dispatchEvent(
    new CustomEvent<MenuItemActivatedDetail>(MENU_ITEM_ACTIVATED_EVENT, { detail: { menuItemId } }),
  );
}
